import Image from "next/image";
import { ContentPlateProps } from "./ContentPlate.types";
import { IFrame } from "../../atoms/IFrame";
import { Flame } from "../../atoms/Flame";
import styles from "./ContentPlate.module.css";
import { CSSProperties } from "react";

export function ContentPlate({
  orientation = "left",
  backgroundCss = "none",
  backgroundImage,
  backgroundImageAlt,
  embedUrl,
  foregroundImage,
  foregroundImageAlt,
  foregroundAnimate = false,
  foregroundImageLoading,
  flameColor,
  children,
  ...rest
}: ContentPlateProps) {
  const showForeground =
    typeof foregroundImage !== "undefined" &&
    typeof foregroundImageAlt !== "undefined" &&
    typeof embedUrl === "undefined";
  return (
    <section
      className={styles.root}
      {...rest}
      data-testid={ContentPlate.displayName}
    >
      {((backgroundImage && backgroundImageAlt) || backgroundCss) && (
        <figure
          className={styles.backgroundWrapper}
          style={{ "--background": backgroundCss } as CSSProperties}
        >
          {backgroundImage && backgroundImageAlt && (
            <Image src={backgroundImage} alt={backgroundImageAlt} />
          )}
        </figure>
      )}
      <div
        className={styles.inner}
        style={
          {
            "--orientation": orientation === "left" ? "row" : "row-reverse",
          } as CSSProperties
        }
      >
        <div className={styles.copyBox}>{children}</div>
        {embedUrl && foregroundImage && (
          <div className={styles.frameBoxWrapper}>
            <IFrame
              src={embedUrl}
              title=""
              placeholder={{
                alt: foregroundImageAlt || "",
                image: foregroundImage,
              }}
            />
          </div>
        )}
        {flameColor && (
          <div className={styles.flameBox}>
            <Flame className={styles.flame} baseColor={flameColor} />
          </div>
        )}
        {showForeground && (
          <figure
            className={`${styles.foregroundWrapper} ${foregroundAnimate ? styles.animate : ""}`}
          >
            <Image
              className={styles.foregroundImage}
              src={foregroundImage}
              alt={foregroundImageAlt}
              sizes={"(max-width: 400px) 100vw, 400px"}
              loading={foregroundImageLoading}
            />
          </figure>
        )}
      </div>
    </section>
  );
}
ContentPlate.displayName = "ContentPlate";
